<div class="spinner">
    <i class="pi pi-spin pi-spinner" style="font-size: 4rem"></i>
    <h3>Loading...</h3>
</div>